import { Badge, BadgeType } from '../../../../../../components/badge/badge';

interface PolicyResultBadgeProps {
    isPassed: boolean;
}

const PolicyResultBadge: React.FC<PolicyResultBadgeProps> = ({ 
    isPassed
}) => {
    return (
        <Badge 
            type={isPassed ? BadgeType.SUCCESS : BadgeType.WARNING}
            text={isPassed ? 'Passed' : 'Failed'}
        />
    );
};

export default PolicyResultBadge;
